const paymentMethods = {
  creditCard: 'creditCard',
  payPal: 'payPal',
  applePay: 'applePay',
  amazonPay: 'amazonPay',
} as const


export type PaymentMethod = keyof typeof paymentMethods

export default paymentMethods
